import type { JSX } from 'react';
import { MedicalProtocol } from '@frontend/components/elements/MedicalProtocol';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';

export function PatientEpisodeCategoryMedicalProtocol(): JSX.Element {
    const { episodeCategory } = usePatientEpisodeCategoryContext();

    return <MedicalProtocol episodeCategoryName={episodeCategory} />;
}
